import { render, staticRenderFns } from "./editApps.vue?vue&type=template&id=a50f31fe&"
import script from "./editApps.vue?vue&type=script&lang=js&"
export * from "./editApps.vue?vue&type=script&lang=js&"
import style0 from "./editApps.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports